import type { AnalyticsPoint } from '@/types/api'

export function SimpleChart({ points }: { points?: AnalyticsPoint[] | null }) {
  const safePoints = Array.isArray(points) ? points : []
  if (safePoints.length === 0) {
    return <div className="py-12 text-center font-mono text-xs text-slate-400">No activity volume in this range.</div>
  }
  const max = Math.max(...safePoints.map((p) => p.count), 1)
  const width = 100 / safePoints.length

  const firstDate = safePoints[0]?.date || ''
  const midDate = safePoints[Math.floor(safePoints.length / 2)]?.date || ''
  const lastDate = safePoints[safePoints.length - 1]?.date || ''

  return (
    <div className="space-y-3">
      <div className="flex h-48 items-end gap-[4px] pt-8 border-b border-slate-100">
        {safePoints.map((p) => (
          <div key={p.date} className="group relative flex-1 h-full flex items-end" style={{ width: `${width}%` }}>
            <div
              className={`w-full rounded-t-md transition-all duration-200 ${
                p.count > 0
                  ? 'bg-gradient-to-t from-sky-600 to-sky-400 hover:from-sky-500 hover:to-blue-400 shadow-xs'
                  : 'bg-slate-100 hover:bg-slate-200'
              }`}
              style={{ height: `${(p.count / max) * 100}%`, minHeight: p.count > 0 ? 8 : 2 }}
            />
            <div className="pointer-events-none absolute -top-9 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-lg border border-slate-700 bg-slate-900 px-2.5 py-1 font-mono text-[11px] font-bold text-white shadow-xl opacity-0 transition-opacity group-hover:opacity-100 z-20">
              <span className="text-sky-300 font-semibold">{p.date}:</span> {p.count} events
            </div>
          </div>
        ))}
      </div>
      <div className="flex justify-between text-[10.5px] font-mono font-medium text-slate-400 px-1">
        <span>{firstDate}</span>
        <span>{midDate}</span>
        <span>{lastDate}</span>
      </div>
    </div>
  )
}
